
import LotterySectionTitle from "./LotterySectionTitle.vue";

export default {
  name: "LotteryMyPrizes",
  components: {
    LotterySectionTitle,
  },
  props: {
    prizes: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 9,
    },
    paginationLayout: {
      type: String,
      default: "total, prev, pager, next, jumper",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
    copy: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // 将接口时间裁剪成页面展示需要的分钟粒度。
    formatTime(value) {
      if (!value) {
        return "";
      }
      return String(value).replace("T", " ").slice(0, 16);
    },
    // 页码变化交给页面重新拉取我的奖品列表。
    handlePageChange(page) {
      this.$emit("page-change", page);
    },
    // 空状态点击时通知页面回到抽奖区域。
    scrollToDraw() {
      this.$emit("scroll-draw");
    },
    // 实物奖品需要填写或展示收货地址。
    isPhysicalPrize(item) {
      return this.getPrizeType(item) === 1;
    },
    // 积分奖品无需展示券码类详情。
    isPointsPrize(item) {
      return this.getPrizeType(item) === 4;
    },
    // 优惠券和兑换码类奖品允许复制明细。
    isCopyablePrize(item) {
      const prizeType = this.getPrizeType(item);
      return prizeType === 2 || prizeType === 3;
    },
    // 兼容 prizeType 与 type 两种奖品类型字段。
    getPrizeType(item) {
      return Number(item?.prizeType || item?.type);
    },
    // 判断当前实物奖品是否还需要补填收货地址。
    canFillPrizeAddress(item) {
      return this.isPhysicalPrize(item) && !item.address && Number(item.claimStatus) !== 2;
    },
    // 判断当前奖品是否存在可复制的券码或 key。
    canCopyPrizeDetail(item) {
      return this.isCopyablePrize(item) && Boolean(this.getCopyablePrizeValue(item));
    },
    // 将 prizeDetail 统一解析为对象，便于读取不同奖品类型的复制字段。
    parsePrizeDetailObject(detail) {
      if (detail === null || detail === undefined || detail === "") {
        return null;
      }

      if (typeof detail === "object" && !Array.isArray(detail)) {
        return detail;
      }

      if (typeof detail === "string") {
        try {
          const parsed = JSON.parse(detail);
          if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
            return parsed;
          }
        } catch (e) {}
      }

      return null;
    },
    // 根据奖品类型提取最终写入剪贴板的值。
    getCopyablePrizeValue(item) {
      const prizeType = this.getPrizeType(item);
      const detail = this.parsePrizeDetailObject(item?.prizeDetail);
      if (!detail) {
        return "";
      }

      if (prizeType === 3) {
        const key = detail.key;
        return key === undefined || key === null ? "" : String(key);
      }

      if (prizeType === 2) {
        const code = detail.code;
        return code === undefined || code === null ? "" : String(code);
      }

      return "";
    },
    // 将不同结构的 prizeDetail 转成可读文本。
    formatPrizeDetail(item) {
      const detail = item?.prizeDetail;
      if (detail === null || detail === undefined || detail === "") {
        return "";
      }

      if (typeof detail === "string" || typeof detail === "number") {
        return String(detail);
      }

      if (Array.isArray(detail)) {
        return detail.filter(Boolean).join("\n");
      }

      if (typeof detail === "object") {
        return Object.keys(detail)
          .filter((key) => detail[key] !== undefined && detail[key] !== null && detail[key] !== "")
          .map((key) => `${key}: ${detail[key]}`)
          .join("\n");
      }

      return "";
    },
    // 复制我的奖品中的券码或兑换 key。
    async copyMyPrizeDetail(item) {
      const text = this.getCopyablePrizeValue(item);
      if (!text) {
        return;
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          this.copyTextFallback(text);
        }
        this.$message.success("Copy successful");
      } catch (e) {
        this.$message.error("Copy failed");
      }
    },
    // 非安全上下文下使用隐藏 textarea 兜底复制文本。
    copyTextFallback(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "readonly");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
    // 通知页面打开地址弹窗并绑定当前奖品记录。
    claimAddressForPrize(item) {
      this.$emit("claim-address", item);
    },
    // 拼接地址里的收件人、电话、邮箱信息。
    formatAddressNameLine(address = {}) {
      const firstName = address.firstName || "";
      const lastName = address.lastName || "";
      const mobile = address.mobile || "";
      const email = address.email || "";
      return [firstName, lastName, mobile, email].filter(Boolean).join(" - ");
    },
    // 拼接地址里的街道、城市、省份、邮编、国家信息。
    formatAddressStreetLine(address = {}) {
      const street = [address.address1, address.address2].filter(Boolean).join(", ");
      const city = address.cityName || "";
      const province = address.provinceName || "";
      const zipcode = address.zipcode || "";
      const country = address.countryName || "";
      return [street, city, province, zipcode, country].filter(Boolean).join(" - ");
    },
  },
};
